import React from "react";
import { shape, string } from "prop-types";

import { twMerge } from "tailwind-merge";

const Address = ({ detail, className, ...props }) => {
  const { street, streetNumber, address1, city, town, postcode, name } = detail;

  return (
    <address
      className={twMerge("text-sm not-italic flex flex-col gap-1", className)}
      {...props}
    >
      {name && <span data-id="address-name">{name}</span>}
      <span data-id="address-street">
        {address1 || `${street} ${streetNumber}`}
      </span>
      <span data-id="address-zip-city">
        {postcode} {city || town}
      </span>
    </address>
  );
};

Address.propTypes = {
  className: string,
  detail: shape({
    userLastName: string,
    userFirstName: string,
    street: string,
    address1: string,
    streetNumber: string,
    city: string,
    town: string,
    postcode: string,
  }).isRequired,
};

export default Address;
